import PluginController from './plugin-core-system/plugin.controller.js';

import CsPhoneLinks from './essentials/cs-phone-links.js';
import CsExternalLinks from './essentials/cs-external-links.js';
import CsScrollbar from './essentials/cs-scrollbar.js';

import CsFormFields from './plugins/cs-form-fields.js';

import CsGlobal from './plugins/cs-global.js';
import CsSplide from './plugins/cs-splide.js';
import CsAccordion from './plugins/cs-accordion.js';

PluginController.addPlugin('CsPhoneLinks', CsPhoneLinks, 'a[href^="tel:"]');
PluginController.addPlugin('CsExternalLinks', CsExternalLinks, 'a[target="_blank"]');
PluginController.addPlugin('CsScrollbar', CsScrollbar);
PluginController.addPlugin('CsFormFields', CsFormFields);

PluginController.addPlugin('CsGlobal', CsGlobal);
PluginController.addPlugin('CsSplide', CsSplide, '.js-slider');
PluginController.addPlugin('CsAccordion', CsAccordion, '.js-accordion-new');


document.addEventListener('DOMContentLoaded',
  () => PluginController.initializeAllPlugins(), false);
